import { Button } from "@tblabs/truffle";


export class SecondaryButton extends Button
{
    constructor(label: string, action?: (self: SecondaryButton) => void)
    {
        super(label, action);

        this.Class("button secondary");
    }
}
